import * as API from '@/services/API';
export default {
  add({ commit }, payload) {
    return API.apiClient
      .post('/offices', payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  delete({ commit }, id) {
    return API.apiClient
      .delete('/offices/' + id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  update({ commit }, payload) {
    return API.apiClient
      .put('/offices/' + payload.id, payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  view({ commit }, id) {
    return API.apiClient
      .get('/offices/' + id)
      .then((response) => {
        commit('SET_CURRENT_OFFICE', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  list({ commit }) {
    return API.apiClient
      .get('/offices')
      .then((response) => {
        commit('SET_LIST', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
